import type { Ref } from 'vue';
import { computed, ref } from 'vue';
import { convertTournamentKnockout } from '@/core/oddsApi/helpers/formatTournamentKnockout';
import { useTournamentKnockoutQuery } from '@/core/oddsApi/oddsApiType';
import type { IKnockoutStage } from '@/interface/tournamentCenter';

export function useTournamentKnockout(leagueId: Ref<number>) {
    const knockoutStages = ref<IKnockoutStage[]>([]);

    const variables = computed(() => ({
        query: {
            leagueId: leagueId.value,
        },
    }));

    const { onResult, loaded } = useTournamentKnockoutQuery(
        variables,
        { pollInterval: 60000 },
    );

    onResult((result) => {
        knockoutStages.value = (result ?? []).map(convertTournamentKnockout);
    });

    return {
        knockoutStages,
        loaded,
    };
}
